import ApiClient from './ApiClient';

class EmailTemplatesAPI extends ApiClient {
  constructor() {
    super('email_templates', { accountScoped: true });
  }

  getPreview(id, values = {}) {
    const params = new URLSearchParams();
    if (values && Object.keys(values).length) {
      Object.entries(values).forEach(([key, val]) => {
        params.append(`values[${key}]`, val);
      });
    }
    const query = params.toString();
    return axios.get(`${this.url}/${id}/preview${query ? `?${query}` : ''}`);
  }

  attachFile(file) {
    const formData = new FormData();
    formData.append('attachment', file);
    return axios.post(`${this.url}/attach_file`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  aiSuggest(query) {
    return axios.post(`${this.url}/ai_suggest`, { query });
  }
}

export default new EmailTemplatesAPI();
